import { Link } from "gatsby";
import React from "react";

const Footer = () => {
  return (
    <footer className="xl:px-0 px-[1rem] max-w-[1280px] mx-auto mb-[50px]">
      <hr className="h-[5px] w-full bg-black" />
      <div className="flex justify-around py-[5rem]">
        <Link to="/eula" className="underline">
          EULA
        </Link>
        <Link to="/privacy" className="underline">
          Política de privacidad
        </Link>
        <Link
          to="/"
          className="underline"
        >
          Contacto
        </Link>
      </div>
      <hr className="h-[2px] w-full" />
      <div className="text-center pt-[20px]">
        <span className="text-center mx-auto">© 2023 Allappsme.com</span>
      </div>
    </footer>
  );
};

export default Footer;
